import CommonFieldName from "./CommonFieldName";

enum ActivityFieldName {
  ACTIONS = "actions",
  NAME = CommonFieldName.NAME,
  COMPANY = CommonFieldName.COMPANY,
  PERSON = CommonFieldName.PERSON,
  PEOPLE = "contacts",
  COMPANY_ADDRESS = "account.address",
  PERSON_ADDRESS = "contact.address",
  DEAL = "deal",
  ACTIVITY_TYPE = "activityType",
  CREATOR = CommonFieldName.CREATOR,
  CREATOR_NAME = CommonFieldName.CREATOR_NAME,
  CREATOR_EMAIL = CommonFieldName.CREATOR_EMAIL,
  USER = CommonFieldName.USER,
  OWNER_NAME = CommonFieldName.OWNER_NAME,
  OWNER_EMAIL = CommonFieldName.OWNER_EMAIL,
  COMPLETED = "completed",
  VISIBILITY = "visibility",
  CREATED_AT = CommonFieldName.CREATED_AT,
  UPDATED_AT = CommonFieldName.UPDATED_AT,
  START_AT = "startAt",
  START_DATE = "startDate",
  START_TIME = "startTime",
  END_AT = "endAt",
  END_DATE = "endDate",
  END_TIME = "endTime",
  SOURCE = CommonFieldName.SOURCE,
  COMPLETED_AT = "completedAt",
  COMPLETED_TIME = "completedTime",
  COMPLETED_DATE = "completedDate",
  STATUS = "status",
  NOTE = "note",
  ASSIGNEE = "assignee",
  ASSIGNEE_NAME = "assignee.fullName",
  ASSIGNEE_EMAIL = "assignee.username",
  ASSIGNEE_TEAM_NAME = "assigneeTeamName",
  DURATION = "duration",
  UNIQUE_ID = CommonFieldName.UNIQUE_ID,
  CRM_LINK = CommonFieldName.CRM_LINK,
  FREQUENCY = "recurInterval",
  GEOPOINT_CHECK_IN = "geoPointCheckin",
  CHECK_IN_DISTANCE = "distanceBetweenCheckInAndEntity",
  CHECK_IN_TIME = "checkinTime",
  CHECK_OUT_TIME = "checkoutTime",
  RELIABILITY = "reliability",
  QUICK_FILTER = "quickFilter",
  TEAM = "teams",
  FILES = CommonFieldName.FILES,
  ACCOUNT_IMPORT_ID = CommonFieldName.COMPANY_IMPORT_ID,
  CONTACT_IMPORT_ID = CommonFieldName.PERSON_IMPORT_ID,
  DEAL_IMPORT_ID = "deal.importId",
  PRIMARY_ASSOCIATION = "primaryAssociation",
  UNRELIABLE_REASONS = "unreliableReasons",
}

export default ActivityFieldName;
